import { type FC } from "react";

import { humanReadableFileSize } from "widgets/utils";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import TableCellNumber from "./core/TableCellNumber.js";
import { type IdentifiableFileData } from "@/modules/files/components/FileBrowser.js";

/**
 * Please make sure that
 * - if props.value and props.valueFormatted are both null -> render empty cell
 * - if props.valueFormatted==0 -> render '<1 KB'
 */
const FileSizeCell: FC<IAgGridCellProps> = (props) => {
  const val = props.valueFormatted ? props.valueFormatted : props.value;
  const data: IdentifiableFileData = props.data;
  if (val == null || data.file.fileBrowseType !== "REGULAR_FILE") {
    return null;
  }

  const { size, unit } = humanReadableFileSize(val);
  const renderedText = `${size} ${unit}`;
  return <TableCellNumber {...props} valueFormatted={renderedText} />;
};

export default FileSizeCell;
